import React, { useState, useEffect, FC } from 'react'
import { message, Table } from 'antd'
import { Link } from 'react-router-dom'
import { SearchBar } from '../../../components'
import { Reseller } from '../../../types'
import { serviceProviderService } from '../../../services'
import styles from './index.module.less'

const { Column } = Table

interface ChildAccountsProps {
	id: number
}

const ChildAccounts: FC<ChildAccountsProps> = ({ id }) => {
	const [resellers, setResellers] = useState<Reseller[]>(null)
	const [filter, setFilter] = useState<string>('')

	useEffect(() => {
		const init = async () => {
			try {
				const { data } = await serviceProviderService.getChildren(id)
				setResellers(data)
			} catch (error) {
				const defaultErrorMessage = 'Something went wrong, unable to get children for service provider.'
				message.error(defaultErrorMessage)
			}
		}
		init()
	}, [id])

	const filteredResellers = resellers ? resellers.filter(reseller => reseller.name.toLowerCase().includes(filter.toLowerCase())) : []

	return (
		<>
			<SearchBar className={styles.filter} search={setFilter} placeholder='Filter resellers by name' />
			<Table rowKey='id' loading={resellers === null} dataSource={filteredResellers}>
				<Column
					title='Name'
					dataIndex='name'
					render={(_, reseller: Reseller): React.ReactNode => <Link to={`/reseller/${reseller.id}/children`}>{reseller.name}</Link>}
				/>
				<Column title='Contact' dataIndex='contact' />
			</Table>
		</>
	)
}

export default ChildAccounts
